import { QueryClient } from "@tanstack/react-query";
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
        },
    }
});

export const localStoragePersister = createSyncStoragePersister({
    storage: window.localStorage,
  })

// export const useQueryStore = (
//     queryKey: (string | undefined)[]
//   ): AxiosResponse => queryClient.getQueryData(queryKey) as AxiosResponse;

export const useQueryStore = <T = any, R = any>(
    queryKey: (string | undefined)[],
    select?: (data: T) => R
  ): R | undefined => {
    const cachedData = queryClient.getQueryData<T>(queryKey);
    return select && cachedData ? select(cachedData) : (cachedData as unknown as R);
  };